import React from 'react'
import T from 'prop-types'
import _ from 'lodash'
import Button from './Button'


const TAG_SHAPE = T.shape({
  name: T.string,
  id: T.any.isRequired,
  _status: T.string,
  _isPending: T.bool
})

class Tag extends React.Component {
  static displayName = 'Tag'

  static propTypes = {
    className: T.string,
    onClick: T.func,
    onRemove: T.func,
    removeTooltip: T.string,
    tag: TAG_SHAPE,
    tagContentComponent: T.any, // Component to use when rendering inner tag content
    tagContentPropTransformer: T.func, // Mapping function that should return props passed to the tagContentComponent. Receives `tag` data as its only argument
    tooltip: T.string
  }

  _handleFn = (propFunc) => {
    const _func = this.props[propFunc]
    if (_func && _.isFunction(_func)) {
      _func(this.props.tag)
    }
  }

  _onClick = () => {
    const _func = this.props.onClick
    if (_func && _.isFunction(_func)) {
      _func(this.props.tag)
    }
  }

  _onRemove = () => {
    const _func = this.props.onRemove
    if (_func && _.isFunction(_func)) {
      _func(this.props.tag)
    }
  }

  render() {
    const { props } = this
    const tag = props.tag
    let content = tag.name
    if (props.tagContentComponent && props.tagContentPropTransformer) {
      content = React.createElement(
        props.tagContentComponent,
        props.tagContentPropTransformer(tag)
      )
    }
    return (
      <div
        className={'pw_tag tag_status_' + tag._status + ' ' + props.className}
        data-tooltip={props.tooltip}
        onClick={this._onClick}
      >
        {content}
        {tag._isPending || !props.onRemove
          ? null
          : <Button
              className="icon icon-close remove"
              data-tooltip={props.removeTooltip}
              onClick={this._onRemove}
            />}
      </div>
    )
  }
}


export default Tag
